module.exports = __webpack_public_path__ + "c6ba47b488431da118e3b8baf5c9c099.svg";